<ng-container *ngIf="compactUi; else fullAttachmentLayout">
  <div class="flex flex-col gap-2">
    <div
      class="flex items-center gap-2"
      [class.opacity-50]="disabled"
      [class.pointer-events-none]="disabled"
    >
      <input
        #compactFileBtn
        type="file"
        hidden
        multiple
        (change)="handleFileInput($event)"
        accept=".heic,.HEIC,.jpg,.pdf,.png,.doc,.docx,.xls,.xlsx"
      />
      <button
        type="button"
        class="inline-flex items-center cursor-pointer justify-center gap-1 h-8 px-2.5 rounded-md border border-[#E3E6EE] bg-white text-xs font-medium text-[#15191E] hover:bg-[#F9FAFB] shrink-0"
        matTooltip="Add attachments(HEIC, JPG, PNG, PDF, DOC, DOCX, XLS, XLSX)"
        matTooltipPosition="above"
        [disabled]="disabled || lstFiles.length >= maxFiles"
        (click)="compactFileBtn.click()"
      >
        <img src="./assets/images/icons/setup/add.svg" class="w-3.5 h-3.5" alt="" />
        Attachments
      </button>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
      <ng-container *ngFor="let f of lstFiles">
        <div
          class="inline-flex items-center gap-1.5 min-w-0 rounded-md border border-[#E3E6EE] bg-[#FBFBFC] pl-1 pr-1 py-0.5 text-xs text-[#15191E]"
        >
          <img
            *ngIf="isImageFile(f)"
            [src]="previewUrlFor(f)"
            alt=""
            class="w-7 h-7 rounded object-cover shrink-0 border border-[#F1F1F4]"
          />
          <img
            *ngIf="!isImageFile(f)"
            [src]="getFileIcon(f.name)"
            alt=""
            class="w-6 h-6 shrink-0"
          />
          <span class="truncate min-w-0 flex-1" [title]="f.name">{{ truncateFileName(f.name) }}</span>
          <button
            type="button"
            class="shrink-0 flex items-center justify-center size-6 rounded hover:bg-[#E8E8EC] text-[#60646C] leading-none"
            [disabled]="disabled"
            (click)="remove(f.name); $event.stopPropagation()"
            aria-label="Remove attachment"
          >
            ×
          </button>
        </div>
      </ng-container>
    </div>

  </div>
</ng-container>

<ng-template #fullAttachmentLayout>
  <div class="md:mb-5 mb-3">
    <h2 class="font-medium md:text-lg text-md leading-6 md:mb-2 mb-0.5">Attachments</h2>
    <p class="font-normal md:text-sm text-xs leading-5 text-[#60646C] ">Attach documents or files related to a ticket for better
      context and collaboration.</p>
  </div>
    <div [class.opacity-50]="disabled"
        [class.pointer-events-none]="disabled"
        [attr.aria-disabled]="disabled"
        (click)="!disabled && filebtn.click()"
        (keydown.enter)="!disabled && filebtn.click()"
         tabindex="0"
         role="button"
        class="border-2 border-dashed border-[#42578A26] py-10 md:px-0 px-5 flex justify-center items-center gap-4 mb-4">
   <img src="./assets/images/icons/setup/add.svg" alt="">
    <div class="flex justify-start items-start flex-col">
      <input type="file" hidden multiple #filebtn (change)="handleFileInput($event)" accept=".heic,.HEIC,.jpg,.pdf,.png,.doc,.docx,.xls,.xlsx">

      <p class="font-medium md:text-sm text-xs leading-5 text-[#15191E] mb-1.5">Click to browse or drag attachments here</p>
      <p class="text-[#60646C] font-normal text-xs leading-4">HEIC, JPG, PDF, PNG, DOCX, XLSX</p>
    </div>
  </div>
 <div class="flex flex-wrap gap-6 mb-7">
  <ng-container *ngFor="let note of mongoNotes">

    <ng-container *ngIf="note.attachments?.length">

      <div
        *ngFor="let attachment of note.attachments; let i = index"
        class="relative group w-[192px] shrink-0 rounded-[10px] border border-[#F1F1F4] p-2 overflow-hidden"
      >

        <a
          rel="noopener noreferrer"
          (click)="showImageViewer(getAttachmentPaths(note.attachments), i)"
          (keydown.enter)="showImageViewer(getAttachmentPaths(note.attachments), i)"
          role="button"
          tabindex="0"
          class="block relative w-full"
        >

          <!-- Image -->
          <ng-container *ngIf="['jpg','jpeg','png'].includes(getFileExtension(attachment.attachmentUrl)); else checkPdf">
            <img
              [src]="attachment.attachmentUrl"
              alt="image"
              class="w-full h-28 min-28 object-cover rounded-md border border-[#F1F1F4]"
            />
          </ng-container>

          <!-- PDF -->
          <ng-template #checkPdf>
            <ng-container *ngIf="getFileExtension(attachment.attachmentUrl) === 'pdf'; else otherFile">
              <pdf-viewer
                [src]="attachment.attachmentUrl"
                [render-text]="true"
                [show-all]="false"
                [page]="1"
                [original-size]="false"
                [fit-to-page]="true"
                [autoresize]="true"
                class="h-28 min-28 rounded-md border border-[#F1F1F4] overflow-hidden"
              >
              </pdf-viewer>
            </ng-container>
          </ng-template>

          <!-- Other Files -->
          <ng-template #otherFile>
            <div class="flex items-center justify-center w-full bg-[#F3F3F3] h-28 min-28 rounded-md border border-[#F1F1F4]">
              <img
                [src]="getFileIcon(attachment.attachmentUrl)"
                alt="file icon"
                class="w-[52px] h-[52px]"
              />
            </div>
          </ng-template>

        </a>

        <div class="mt-2">
          <h3 class="font-medium text-[13px] leading-5 text-[#15191E] mb-0.5">
            {{ truncateFileName(attachment.attachmentUrl) }}
          </h3>

          <h3 class="font-normal text-xs leading-4 text-[#60646C]">
            {{
              utcToTimeZone.convertUTCToLocalTime(
                note.updatedOn,
                parentTimeZone ?? 'utc+5'
              ) | date:'dd MMM yyyy h:mm a'
            }}
          </h3>
        </div>

      </div>

    </ng-container>

  </ng-container>
</div>
</ng-template>
